import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './Heading.module.scss';

const Heading: React.FC = () => {
	return (
		<div className={style.container} data-test="Heading">
			<Text translationNameSpace="listing" translationKey="tabletAppLabel" size="xxl" weight="bold" />
			<svg className={style.icon}>
				<use xlinkHref={`${breadcrumbs}#firmwareAndApp`} />
			</svg>
		</div>
	);
};

export default Heading;
